<template>
  <div class="min-h-screen flex items-start pt-20">
    <!-- Page content -->
    <div class="container pt-10 md:pb-20">
      <!-- Internet Explorer Popup -->
      <modal :show.sync="msie" modalContentClasses="h-auto" @close="close = true">
        <div class="bg-card bg-white border-card-border">
          <div class="flex flex-col items-center justify-center container py-10">
            <div class="text-gray-800">
              <h1 class="text-center text-lg font-semibold mb-2">⚠️ Unsupported Browser ⚠️</h1>
              <p class="mb-2 text-center">VIVA Finance does not support Internet Explorer.</p>
              <p class="text-center">Please visit viva-finance.com from another browser.</p>
              <p class="text-center">(Microsoft Edge, Google Chrome, or Mozilla Firefox)</p>
            </div>
          </div>
        </div>
      </modal>
      <img
        height="1"
        width="1"
        style="border-style: none"
        alt=""
        src="https://insight.adsrvr.org/track/pxl/?adv=udguyav&ct=0:py87fau&fmt=3"
      />
      <!-- Table -->
      <div class="flex pt-5 md:pt-16 pb-4 md:pb-20 px-2">
        <div class="w-full md:w-3/5 dashboard-card card-shadow px-2 md:p-4">
          <div class="flex flex-col justify-center items-start mb-4">
            <h2 class="text-xl font-semibold mb-1">{{ header.h1 }}</h2>
            <h4 class="text-lead mb-4">
              {{
                isLoginPage
                  ? `Before checking your rate, please login to your account with VIVA Finance.`
                  : `Before checking your rate, please create your account with VIVA Finance.`
              }}
            </h4>
            <div class="h-1 w-6 rounded bg-blue-300 mb-4"></div>
          </div>
          <h4 class="text-lead mb-4">{{ header.h2 }}</h4>

          <div>
            <div v-if="!$store.getters.verifying && !$store.getters.authenticated">
              <div v-if="$route.path.includes('register')">
                <p class="text-base font-medium mb-3">
                  Already have an account?
                  <button
                    class="underline text-blue-500 hover:text-secondary"
                    @click="signInInstead"
                  >
                    Sign In
                  </button>
                </p>
                <Input
                  v-model="email"
                  type="text"
                  bg="gray-100"
                  name="Work Email"
                  placeholder="john@employer.com"
                  :suffix="workEmailSuffix"
                  :setter="$setters.email"
                  class="w-full px-1"
                  :transitionsEnabled="false"
                  @enterClicked="enterNext"
                  :error="emailError"
                />
                <div class="flex justify-center mt-5 pl-1">
                  <button
                    class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                    aria-label="terms"
                    @click="terms.viva = !terms.viva"
                  >
                    <i v-if="terms.viva" class="fas fa-check text-sm font-bold text-green-500"></i>
                  </button>
                  <p class="ml-2 text-xs">
                    By signing up, I agree to the VIVA Finance
                    <router-link
                      to="terms"
                      class="underline text-blue-500 hover:text-secondary"
                      target="_blank"
                      rel="noopener"
                      >Terms of Service</router-link
                    >,
                    <router-link
                      to="privacy"
                      class="underline text-blue-500 hover:text-secondary"
                      target="_blank"
                      rel="noopener"
                      >Privacy Policy</router-link
                    >,
                    <router-link
                      to="tcpa"
                      class="underline text-blue-500 hover:text-secondary"
                      target="_blank"
                      rel="noopener"
                      >TCPA Communication Policy</router-link
                    >, and to the use of
                    <router-link
                      to="esign"
                      class="underline text-blue-500 hover:text-secondary"
                      target="_blank"
                      rel="noopener"
                      >Electronic Records and Signatures</router-link
                    >. I authorize VIVA Finance to confirm my income and employment using
                    <a
                      href="https://www.truework.com/products/employees/"
                      class="underline text-blue-500 hover:text-secondary"
                      target="_blank"
                      rel="noopener"
                      >Truework</a
                    >.
                  </p>
                </div>
                <div class="flex justify-center mt-3 pl-1">
                  <button
                    class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                    aria-label="terms"
                    @click="terms.employerRelease = !terms.employerRelease"
                  >
                    <i
                      v-if="terms.employerRelease"
                      class="fas fa-check text-sm font-bold text-green-500"
                    ></i>
                  </button>
                  <p class="ml-2 text-xs">
                    VIVA's loans are not provided by, sponsored, or endorsed by any employer. VIVA
                    Finance is an optional resource and employers in no way benefit from VIVA's
                    loans. VIVA Finance is not directly affiliated with any employers and completely
                    releases employers from any liability. By checking this box, I understand and
                    acknowledge this disclosure.
                  </p>
                </div>
                <div class="flex justify-center mt-3 pl-1">
                  <button
                    class="mt-1 border border-gray-500 bg-gray-300 w-4 h-5 focus:outline-none focus:border-primary px-2 flex items-center justify-center"
                    aria-label="terms"
                    @click="terms.dwolla = !terms.dwolla"
                  >
                    <i
                      v-if="terms.dwolla"
                      class="fas fa-check text-sm font-bold text-green-500"
                    ></i>
                  </button>
                  <p class="ml-2 text-xs">
                    By submitting, you also agree to VIVA's payment partner, Dwolla's
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.dwolla.com/legal/tos/"
                      class="underline text-blue-500 hover:text-secondary"
                      >Terms of Service</a
                    >
                    and
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.dwolla.com/legal/privacy/"
                      class="underline text-blue-500 hover:text-secondary"
                      >Privacy Policy</a
                    >
                    . Dwolla is a partner of Evolve Bank & Trust, member FDIC. By creating an
                    account, you also agree to Evolve's
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://www.dwolla.com/legal/virtual-account-number-personal-account-demand-deposit-agreement/#legal-content"
                      class="underline text-blue-500 hover:text-secondary"
                      >Customer Account Terms</a
                    >
                    and
                    <a
                      target="_blank"
                      rel="noopener"
                      href="https://assets.getevolved.com/cdnevolve/privacy-policy/Consumer-Privacy-Policy-Notice---9.15.20-Final.pdf"
                      class="underline text-blue-500 hover:text-secondary"
                      >Privacy Notice</a
                    >
                  </p>
                </div>
              </div>
              <div v-else>
                <Input
                  v-model="email"
                  bg="gray-100"
                  type="text"
                  :getter="email.match(/^\d{3}/) ? $getters.phone_number : null"
                  :maxlength="email.match(/^\d{3}/) ? 14 : null"
                  :prefix="email.match(/^\d{3}/) ? '+1' : null"
                  :setter="email.match(/^\d{3}/) ? $setters.phone_number : null"
                  name="Phone Number or Email"
                  placeholder="john@employer.com"
                  class="mb-4"
                  @enterClicked="enterNext"
                />
                <p class="text-base mt-3">
                  Don't have an account yet?
                  <button
                    class="underline text-blue-500 hover:text-secondary"
                    aria-label="register"
                    @click="$router.push({ name: 'Register', query: $route.query })"
                  >
                    Create your account
                  </button>
                </p>
              </div>
            </div>
            <transition name="in--right">
              <div v-if="$store.getters.verifying">
                <p class="mb-4 font-medium text-sm md:text-base">
                  A confirmation code was sent to
                  {{ alias.includes('@') ? alias : $getters.phone_number(email) }}. Please enter the
                  6 digit code below or
                  <button
                    type="btn"
                    class="text-blue-500 underline"
                    aria-label="email change"
                    @click="$Auth.signOut()"
                  >
                    Change {{ alias.includes('@') ? 'email address' : 'phone number' }}
                  </button>
                </p>
                <Input
                  v-model="code"
                  bg="gray-100"
                  type="text"
                  name="Sign In Code"
                  maxlength="6"
                  :instantFocus="true"
                  placeholder="123456"
                  class="mb-3 text-sm md:text-lg font-semibold w-64 text-center"
                  @enterClicked="enterNext"
                />
                <div>
                  <p class="pt-3 mb-4 font-medium text-sm">
                    <span v-if="alias.includes('@')" class="mr-2"
                      >Didn't receive an email? Be sure to check your junk/spam!</span
                    >
                    <span v-else class="mr-2">Didn't receive a Text?</span>
                    <button
                      aria-label="code"
                      class="text-sm text-blue-500 underline"
                      style="outline: none"
                      @click="
                        $Auth.signIn(alias).then((user) => {
                          $store.commit('updateUser', user)
                          $store.commit('applicationData/updateUser', user)
                        }),
                          (resend = true)
                      "
                    >
                      Resend code
                    </button>
                  </p>

                  <p v-if="resend === true" class="text-primary ml-2">
                    A new code has been sent<i class="far fa-check-circle text-primary ml-2"></i>
                  </p>
                </div>
              </div>
            </transition>
            <div class="flex mt-10">
              <Navigate
                :back="back"
                :disabled="_disabled"
                :error="error"
                :loading="loading"
                :next="nextWrapper"
                :step="step"
                :verifying="verifying"
              />
            </div>
          </div>
        </div>
        <img :src="`img/sketches/${img}.svg`" alt="img" class="hidden md:block w-1/3 ml-8 p-8" />
      </div>
    </div>
  </div>
</template>

<script>
import Navigate from '@/components/VIVA/Navigate.vue'
import Engine from '@/mixins/Engine'

export default {
  components: {
    Navigate
  },
  name: 'register',
  mixins: [Engine],
  data() {
    return {
      green: false,
      toggled: true,
      sub: 'District School/Department',
      showDropdown: false,
      resend: false,
      close: false,
      internetExplorer: false,
      personalEmailUsed: false,
      emailError: ''
    }
  },
  computed: {
    isLoginPage() {
      return this.$route.path.includes('login')
    },
    _disabled() {
      return !this.email
    },
    header() {
      if (this.$route.path.includes('login')) {
        return {
          h1: 'Sign In',
          h2: 'Enter your phone number or email address to sign in to your VIVA account.'
        }
      } else {
        return {
          h1: 'Create your Account',
          h2: (this.$route.query.redirect || '').includes('apply')
            ? 'Before continuing with your loan application, please create your account with VIVA Finance.'
            : 'Create your account with VIVA Finance.'
        }
      }
    },
    img() {
      if (this.$store.getters.verifying) {
        return 'verify'
      } else if (this.$route.path.includes('login')) {
        return 'login'
      } else {
        return 'createAccount'
      }
    },
    msie() {
      return this.internetExplorer
    }
  },
  mounted() {
    this.step = 'creates'
    this.isIe()
    // to work with the Navigate disabled function on login

    this.terms.viva = this.$route.path.includes('login') ? true : false
    this.terms.employerRelease = this.$route.path.includes('login') ? true : false
    this.terms.dwolla = this.$route.path.includes('login') ? true : false
  },
  methods: {
    enterNext() {
      this.next()
    },
    nextWrapper() {
      if (!this.emailError) {
        this.next()
      }
    },
    isIe() {
      const ua = window.navigator.userAgent
      this.internetExplorer = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1
    },
    signInInstead() {
      this.terms.viva = true
      this.terms.dwolla = true
      this.terms.employerRelease = true
      this.$router.push({ name: 'Login', query: this.$route.query })
    }
  },
  watch: {
    '$route.path': function (path) {
      this.error = ''
      this.terms.viva = path.includes('login') ? true : false
      this.terms.dwolla = path.includes('login') ? true : false
      this.terms.employerRelease = path.includes('login') ? true : false
    }
  }
}
</script>
